import { useEffect, useState } from "react";
import useStyles from "../../assets/styles/styles";
import Menu from "../../components/Menu/Menu";
import { Box, Divider, IconButton, Typography } from "@material-ui/core";
import { getDataFilterAppointment, getAfilliatedAppointments, getAfilliatedAppointmentsNext, AppointmentCanceled } from "../../redux/actions/appointmentsActions";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../controls/Select/CustomSelect";
import NotFound from "../../components/HomeLogged/NotFound";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { returnHomeAppointmentHome, setModelAppointmentToRepeatOrModify } from "../../utils/utilsFunctions";
import { useHistory } from "react-router";
import { format } from "date-fns";
import ModalActivities from "../../components/DialogActivities/ModalActivities";
import NextAppointmentCard from "../../components/Appointments/Cards/NextAppointmentCard";
import useTrackPageView from "../../utils/useTrackPageView";
import ShowPeriodFilter from "../../components/ShowPeriodFilter/ShowPeriodFilter";

const userCode = parseInt(window.localStorage.getItem("numeroPersona"));

const persona = {
    numeroPersona: userCode,
    parametroLlamado: "FILTRO HISTORICO TURNO"
};

const paramAll = {
    numeroPersona: userCode,
    solicitudTurnos: "TODOS",
    count: 1000,
    skip: 0,
};

const AppointmentNext = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const trackPageView = useTrackPageView("Mis próximos turnos");
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [openPicker, setOpenPicker] = useState(false);
    const [openModalRepeatAppointment, setOpenModalRepeatAppointment] = useState(false);
    const appointments = useSelector((state) => state.appointmentsReducer);
    const [next, setNext] = useState([]);
    const [groupFamily, setGroupFamily] = useState([]);
    const [selectAffilliate, setSelectAffilliate] = useState({ value: 0, label: "" });
    const [modelAppointment, setModelAppointment] = useState();
    const [cancelItem, setCancelItem] = useState(
        {
            numeroPersona: 0,
            numeroTurno: 0,
            enviarMail: "",
            mail: ""
        });
    const [openModal, setOpenModal] = useState(false);

    const handleChangeWEB = () => e => {
        var nameAffilliated = groupFamily.filter((x) => x.value == e.target.value);
        setSelectAffilliate({ value: nameAffilliated[0].value, label: nameAffilliated[0].label });
    };


    useEffect(() => {
        getNextAppointments();
    }, [selectAffilliate?.value])


    const handleClickCancelAppointment = () => {
        dispatch(AppointmentCanceled(cancelItem));
        var newNext = next?.filter((x) => x.turnoNumero != cancelItem?.numeroTurno);
        setNext(newNext);
        setOpenModal(false)
    };

    const handleClickOpenRepeatModal = (item) => (e) => {
        e.preventDefault();
        setOpenModalRepeatAppointment(prevState => !prevState);
        setModelAppointment(item);
    };

    const handleClickModifyRepeatAppointment = () => {
        setModelAppointmentToRepeatOrModify(modelAppointment, dispatch, userCode, appointments, history);
    };


    const getNextAppointments = () => {
        dispatch(getAfilliatedAppointmentsNext({
            numeroPersona: userCode,
            solicitudTurnos: "PROXIMOS",
            count: 99999,
            skip: 0
        }));
    }

    useEffect(() => {
        trackPageView();
        getNextAppointments();
        dispatch(getDataFilterAppointment(persona));
        dispatch(getAfilliatedAppointments(paramAll));
    }, []);

    useEffect(() => {
        let listGroupFamily = appointments?.filtro?.map((val) => {
            return {
                value: parseInt(val?.numeroPersona), label: val?.apellidoNombre
            };
        });
        if (listGroupFamily?.length > 1) {
            listGroupFamily?.push({
                value: 0, label: "TODOS"
            });
        }
        setGroupFamily(listGroupFamily);
    }, [appointments?.filtro]);

    useEffect(() => {
        groupFamily?.forEach((item) => {
            if (item.value == userCode) {
                setSelectAffilliate({ value: item.value, label: item.label });
            }
        });
    }, [groupFamily]);

    useEffect(() => {
        let list = [];
        if (selectAffilliate?.value == 0 || !selectAffilliate?.value == undefined) {
            list = appointments?.next?.map(element => {
                return element;
            });
        }
        else {
            list = appointments?.next?.filter((x) => selectAffilliate?.value == x.pacienteNumero).map((element) => {
                return element;
            });
        }
        setNext(list);
    }, [selectAffilliate, appointments?.next]);

    useEffect(() => {
        let start = format(dateStart, "yyyy-MM-dd");
        let end = format(dateEnd, "yyyy-MM-dd");
        let list = appointments?.next?.filter((x) => selectAffilliate?.value == x.pacienteNumero).map((element) => {
            return element;
        });
        let nextFilter = list?.filter(x => x.turnoFechHora.split('T')[0] >= start && x.turnoFechHora.split('T')[0] <= end);
        setNext(nextFilter);
    }, [dateStart, dateEnd]);

    return (
        <>
            <Menu />
            <Box className={`${classes.divMyHistoryTurn}`}>
                <Box className={`${classes.divAffilliate} ${classes.divAffilliateMyHistory}`}>
                    <Typography className={classes.textTitleTurn}>Afiliado: </Typography>
                    <CustomSelect
                        className={`${classes.afilliateSelect}`}
                        list={groupFamily}
                        selected={selectAffilliate?.value}
                        customClassList={`${classes.deploymentSelect} ${classes.deploymentSelectMyHistory}`}
                        onChange={handleChangeWEB()}
                    />
                </Box>
                <Box className={classes.homePageUpcomingShifts}>
                    <Box style={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={returnHomeAppointmentHome(history)}>
                            <ArrowBackIcon className={classes.iconFilter} />
                        </IconButton>
                        <Typography className={`${classes.textTitleTurn}`} style={{ textTransform: 'uppercase' }}>
                            Mis próximos turnos
                        </Typography>
                    </Box>
                    <ShowPeriodFilter
                        dateStart={dateStart}
                        dateEnd={dateEnd}
                        setDateStart={setDateStart}
                        setDateEnd={setDateEnd}
                        openPicker={openPicker}
                        setOpenPicker={setOpenPicker}
                        classes={classes}
                    />
                </Box>
                <Divider className={`${classes.formDivider} ${classes.dividerAppointment}`} style={{ margin: "10px 0" }} />
                <Box className={`${classes.listCardMyHistory}`} style={{ display: "flex", justifyContent: "center" }}>
                    {next?.length > 0 ?
                        next?.map((item, key) => (
                            <NextAppointmentCard item={item} i={key} handleClickOpenRepeatModal={handleClickOpenRepeatModal} setCancelItem={setCancelItem} setOpenModal={setOpenModal} />
                        ))
                        :
                        <NotFound customMsg={
                            <Box className={classes.contentNotFound} style={{ marginTop: "10%" }}>
                                <Typography>No tenés próximos turnos</Typography>
                            </Box>}
                            wsItem={next?.filter(nextAppointmentsToFilter => nextAppointmentsToFilter?.pacienteNumero === selectAffilliate?.value)}
                            fullItem={next} />
                    }
                </Box>
                {
                    openModalRepeatAppointment &&
                    <ModalActivities
                        title={'Modificar Turno'}
                        description={'¿Estás seguro que deseas modificar el turno seleccionado?'}
                        open={openModalRepeatAppointment}
                        onClose={setOpenModalRepeatAppointment}
                        modalconfirm={true}
                        modalLogout={false}
                        buttonType={'submit'}
                        handleClick={handleClickModifyRepeatAppointment}
                    />
                }
                {
                    openModal &&
                    <ModalActivities
                        title={"Cancelar turno"}
                        description={"¿Estás seguro que deseas cancelar el turno?"}
                        open={openModal}
                        onClose={setOpenModal}
                        modalconfirm={true}
                        modalLogout={false}
                        buttonType={'submit'}
                        handleClick={handleClickCancelAppointment} />
                }
            </Box>
        </>
    );
};
export default AppointmentNext;